import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NewsfeedContentSource } from '@planone/bau365/data-access-newsfeed';
import { Channel } from '@planone/bau365/data-access-user';

@Component({
  selector: 'bau365-section-channels',
  templateUrl: './section-channels.component.html',
  styleUrls: ['./section-channels.component.scss'],
})
export class SectionChannelsComponent {
  @Input() source: NewsfeedContentSource | undefined | null;
  @Input() sponsoredChannels: Channel[] | undefined | null;
  @Input() subscribedChannels: Channel[] | undefined | null;
  @Input() fairId: string | undefined | null;
  @Input() showHistoryChannel: boolean | undefined | null;

  @Output() selectChannel = new EventEmitter<Channel>();
  @Output() selectForMe = new EventEmitter<void>();
  @Output() selectLastViewed = new EventEmitter<void>();

  forMeChannel = $localize`:@@featureNewsfeed-channels-channel-forMe:Für mich`;
  lastViewedChannel = $localize`:@@featureNewsfeed-channels-channel-lastViewed:Zuletzt angesehen`;

  insightsNewsHeader = $localize`:@@featureNewsfeed-channels-header-insightsNews:INSIGHTS News`;
  subscribedChannelsHeader = $localize`:@@featureNewsfeed-channels-header-subscribedChannels:Abonnierte Unternehmen`;
  myActivitiesHeader = $localize`:@@featureNewsfeed-channels-header-myActivities:Meine Aktivitäten`;

  get addChannelsLink() {
    return `/fairs/${this.fairId}/exhibitors`;
  }
  addChannelsText = $localize`:@@featureNewsfeed-channels-channelGroup-addChannels:Kanäle hinzufügen`;

  onSelectChannel(channel: Channel): void {
    this.selectChannel.emit(channel);
  }

  onSelectForMe(): void {
    this.selectForMe.emit();
  }

  onSelectLastViewed(): void {
    this.selectLastViewed.emit();
  }
}
